import { ToastsAction } from "./toasts.action";

export class ToastsState {
    visibleToasts: Array<any>;
}

export const initialState: ToastsState = {
    visibleToasts: []
}


export function ToastsReducer(state: ToastsState = initialState, action: ToastsAction){

    switch (action.type) {

        case ToastsAction.toastError:
            return state;
        default:
            return state;
    }
};
